export const isProduction = process.env.NODE_ENV === 'production' || process.env.REACT_APP_VERCEL_ENV === 'production';

export const isPreProduction = process.env.NODE_ENV === 'production' || process.env.REACT_APP_VERCEL_ENV === 'preview';

export const isPreview = process.env.REACT_APP_VERCEL_ENV === 'preview';

export const isTest = process.env.NODE_ENV === 'test';

export const isDevelopment = !isPreProduction && !isTest;

/**
 * E2 CLIENT ENVIRONMENT BY DOMAIN
 *
 * It is different with the process environment.
 * Standalone: Preview, independent develop environment
 * Non-Standalone: Production, Staging, Pre-staging and venngage.local
 */

// Running on the venngage production domain
export const isProductionDomain = window.location.hostname === 'infograph.venngage.com';

// Running on the venngage staging domain
export const isStagingDomain = window.location.hostname === 'infograph.venngage.beer';

// Running on the venngage prestaging domain
export const isPreStagingDomain = !isStagingDomain && window.location.hostname.includes('infograph-dev.venngage.beer');

// Running on the venngage.local domain
export const isVenngageLocalDomain = window.location.hostname === 'venngage.local';

// E2 client runs in an independent environment
// VenngageE2 is a global variable that is only available in the e1 environment.
// TODO: Need to refactor this VenngageE2 global variable
export const isStandalone =
  !isProductionDomain && !isStagingDomain && !isPreStagingDomain && !isVenngageLocalDomain && !('VenngageE2' in window);
